import angular = require('angular');
import moment = require('moment');
import { IMenuListItem, IMenuSchedule } from './models';

export class ScheduleService {
    public static $inject = ['$translate'];

    constructor(private $translate: angular.translate.ITranslateService) {}

    public packDaysOfWeek(days: any) {
        let value = 0;
        const keys = Object.keys(days);
        for (let i = 0; i < keys.length; i++) {
            if (days[keys[i]]) {
                value += Math.pow(2, i);
            }
        }
        return value;
    }

    public unpackDaysOfWeek(days: string) {
        return parseInt(days, 10)
            .toString(2)
            .split('')
            .reverse()
            .map((x) => x === '1');
    }

    public renderDaysOfWeek(days: string, isShort: boolean = false) {
        const bits = this.unpackDaysOfWeek(days);
        const translate = [
            'sunday',
            'monday ',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday'
        ];

        if (!bits.some((x) => !x) && bits.length === 7) {
            return this.$translate.instant('all_week');
        }

        let result = '';
        let isSkipping = false;
        for (let i = 0; i < bits.length; i++) {
            const bit = bits[i];
            const haveSkip = !!bits[i - 1] && bit && !!bits[i + 1];

            if (haveSkip) {
                result += isSkipping ? '' : ' - ';
                isSkipping = true;
                continue;
            }

            if (bit) {
                if (result !== '' && !isSkipping) {
                    result += ', ';
                }
                result += this.$translate.instant(translate[i] + (isShort ? '_short' : ''));
            } else {
                isSkipping = false;
            }
        }

        return result;
    }

    public renderActiveDates(startDate: string|Date, endDate: string|Date, format: string = 'DD MMM YYYY') {
        if (startDate !== null && endDate !== null) {
            if (moment(startDate).date() === moment(endDate).date()) {
                if (moment(startDate).date() === moment().date()) {
                    return this.$translate.instant('run_today');
                }
                return this.$translate.instant('run_only', {
                    date: moment(startDate).format(format)
                });
            }

            return this.$translate.instant('run_from_to', {
                start: moment(startDate).format(format),
                end: moment(endDate).format(format)
            });
        }

        if (startDate !== null) {
            return this.$translate.instant('run_from', {
                date: moment(startDate).format(format)
            });
        }

        return '';
    }

    public getFromMenuItem(item: IMenuListItem): IMenuSchedule {
        const unpackedDays = this.unpackDaysOfWeek(item.DaysOfWeek.toString());
        return {
            days: {
                sunday: !!unpackedDays[0],
                monday: !!unpackedDays[1],
                tuesday: !!unpackedDays[2],
                wednesday: !!unpackedDays[3],
                thursday: !!unpackedDays[4],
                friday: !!unpackedDays[5],
                saturday: !!unpackedDays[6]
            },
            anyDays(): boolean {
                return this.days.sunday || this.days.monday || this.days.tuesday || this.days.wednesday ||
                    this.days.thursday || this.days.friday || this.days.saturday;
            },
            setDays(value: boolean) {
                for (let p in this.days) {
                    if (this.days.hasOwnProperty(p)) {
                        this.days[p] = value;
                    }
                }
            },
            startDate:
                item.StartDate == null ? null : moment(item.StartDate).toDate(),
            endDate:
                item.EndDate == null ? null : moment(item.EndDate).toDate(),
            startTime:
                item.StartTime == null
                    ? null
                    : moment(item.StartTime, 'HH:mm:ss').toDate(),
            endTime:
                item.EndTime == null
                    ? null
                    : moment(item.EndTime, 'HH:mm:ss').toDate(),
        };
    }

    public updateMenuItemSchedule(
        schedule: IMenuSchedule,
        item: IMenuListItem
    ) {
        item.StartDate = schedule.startDate;
        item.EndDate = schedule.endDate;
        item.StartTime = moment(schedule.startTime).isValid()
            ? moment(schedule.startTime).format('HH:mm')
            : null;
        item.EndTime = moment(schedule.endTime).isValid()
            ? moment(schedule.endTime).format('HH:mm')
            : null;
        item.DaysOfWeek = this.packDaysOfWeek(schedule.days);
    }
}

angular.module('naut').service('scheduleService', ScheduleService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/menus/schedule.service.ts